'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './LinkUnstyled.module.css';
/**
 * Framework-agnostic link wrapper that resets default anchor styling
 * and exposes a keyboard `:focus-visible` ring (WCAG 2.4.7).
 *
 * Use any time a Card / Row / Stack / PersonRow needs to be a navigable
 * surface. Pass `linkAs` to opt into client-side navigation with your
 * router's Link component (e.g. TanStack Router's `Link`). When `linkAs`
 * is omitted the component falls back to a plain `<a>` tag.
 *
 * Caller-passed `style` merges on top of the unstyling defaults; use
 * for sanctioned structural overrides (`flex`, `minWidth`, positioning).
 */
export function LinkUnstyled({ href, linkAs, style, className, children, ...rest }) {
    const composedClassName = className
        ? `${styles.linkUnstyled} ${className}`
        : styles.linkUnstyled;
    const Component = (linkAs ?? 'a');
    return (_jsx(Component, { href: href, className: composedClassName, ...(style ? { style } : {}), ...rest, children: children }));
}
//# sourceMappingURL=LinkUnstyled.js.map